const BASE_URL = `${LF_API_URL}/ras`

// Normalizes jQuery's jqXHR failure object into a plain, predictable error
// shape so callers don't need to know about jQuery/ajax internals.
function getAPIErrorMessage(jqXHR, responseJSON = jqXHR?.responseJSON) {
  return responseJSON?.message
    ? responseJSON.message +
        (responseJSON.referenceNumber
          ? '&nbsp;&nbsp; | &nbsp;&nbsp;Ref #: ' + responseJSON.referenceNumber
          : '')
    : jqXHR?.statusText
      ? jqXHR.statusText + '&nbsp;&nbsp; | &nbsp;&nbsp;Code: ' + jqXHR.status
      : 'Internal Server Error*'
}

function normalizeError(jqXHR, responseJSON) {
  const status = jqXHR?.status

  return {
    status,
    type: 'unknown',
    message: getAPIErrorMessage(jqXHR, responseJSON),
  }
}

async function normalizeBlobError(jqXHR) {
  let responseJSON = jqXHR?.responseJSON

  if (!responseJSON && jqXHR?.response instanceof Blob) {
    try {
      const responseText = await jqXHR.response.text()
      responseJSON = responseText ? JSON.parse(responseText) : null
    } catch {
      responseJSON = null
    }
  }

  return normalizeError(jqXHR, responseJSON)
}

// Wraps a jQuery ajax POST call in a native Promise so callers get standard
// Promise semantics (resolve with parsed JSON, reject with a normalized error).
function postJson(url, body) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(body),
      dataType: 'json',
    })
      .done((data) => resolve(data))
      .fail((jqXHR) => reject(normalizeError(jqXHR)))
  })
}

function getFileName(contentDisposition) {
  const fallback = 'RAS Transactions Export.xlsx'
  if (!contentDisposition) return fallback

  const encodedFileName = contentDisposition.match(
    /filename\*\s*=\s*UTF-8''([^;]+)/i,
  )?.[1]
  if (encodedFileName) {
    try {
      return decodeURIComponent(encodedFileName.replace(/^"|"$/g, ''))
    } catch {
      return fallback
    }
  }

  return (
    contentDisposition.match(/filename\s*=\s*"([^"]+)"/i)?.[1] ??
    contentDisposition.match(/filename\s*=\s*([^;]+)/i)?.[1]?.trim() ??
    fallback
  )
}

function postBinary(url, body) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(body),
      xhrFields: {
        responseType: 'blob',
      },
    })
      .done((blob, _textStatus, jqXHR) =>
        resolve({
          blob,
          fileName: getFileName(jqXHR.getResponseHeader('Content-Disposition')),
        }),
      )
      .fail(async (jqXHR) => reject(await normalizeBlobError(jqXHR)))
  })
}

export default {
  /** @returns {Promise<Object>} */
  getDashboard({ tab, sortBy = 'rasBenefit', viewAsUserId = 0 } = {}) {
    if (!tab) {
      return Promise.reject({
        status: 400,
        type: 'client',
        message: 'A dashboard tab is required.',
      })
    }

    return postJson(`${BASE_URL}/dashboard`, {
      account_id: '',
      view_as_user_id: viewAsUserId,
      sort_by: sortBy,
      tab,
    })
  },

  /** @returns {Promise<{ blob: Blob, fileName: string }>} */
  exportTransactions({ viewAsUserId = 0, accountList = [] } = {}) {
    return postBinary(`${BASE_URL}/transactions/export`, {
      account_id: '',
      view_as_user_id: viewAsUserId,
      sort_by: '',
      account_list: accountList,
    })
  },
}
